module.exports = __webpack_public_path__ + "static/media/Edilma.bda8c4fe.jpg";